<template lang="pug">
include /@ibkr/lib.common/src/icon/color
include /@ibkr/lib.common/src/icon/basic
div(class="border-bottom insety-16")
    ib-row
        ib-col(class="xl2 s12")
            p(:class="{'insetx-8': $media.xl}")
                span(
                    class="insetx-8 info",
                    :class="{'start-0': !$media.m}"
                )
                    +icon-basic-info_filled
                    span(class="tooltext") {{ $t('choose_asset') }}
                span(class="tooltext") {{ $t('asset_class') }}
        ib-col(class="xl10 s12 insety-16", :class="{'inset-12': $media.xl}")
            div
                ib-button(
                    class="asset-class"
                    :class="{active: option.selected === true}",
                    v-for="(option, index) in options",
                    :key="option.value",
                    @click="select(option)"
                ) 
                    span {{ option.label}}
                    span(
                        v-if="option.active",
                        class="inset-8 fg-positive"
                    )
                        +icon-color-yes
                //-ib-dropdown(
                        :data="options",
                        v-model="selected",
                        class="asset-class",
                        width="225px",
                        :placeholder="$t('select_asset_class')"
                    )
</template>

<script>
    import { mapState, mapActions } from 'vuex';

    export default {
        name: 'AssetSelector',
        data() {
            return {}
        },
        methods: {
            select(option) {
                let newAssets = [];
                const val = option.value;
                if (val === 'all') {
                    newAssets = this.assets.map(item => {
                        return {
                            name: item.name,
                            selected: true
                        }
                    });
                } else {
                    newAssets = this.assets.map(item => {
                        if (item.name === val) {
                            return {
                                name: item.name,
                                selected: true
                            }
                        } else {
                            return {
                                name: item.name,
                                selected: false
                            }
                        }
                    });
                }
                this.setAssets(newAssets);
            },
            ...mapActions(['setAssets'])
        },
        computed: {
            options: function() {
                const list = [];
                
                for (let i = 0; i < this.assets.length; i++) {
                    const label = this.$t(this.assets[i].name);
                    const value = this.assets[i].name;
                    const selected = this.assets[i].selected;
                    list[i] = {label, value, selected};
                }
                list.unshift({ label: this.$t('select_all'), value: "all", selected: list[0].selected && list[1].selected })
                return list;
            },
            ...mapState(['assets'])
        },
    }
</script>

<style scoped lang="less">
.asset-class {
    width: 27%;
    margin-right: 3%;
    text-align: left;
    &:hover {
        border-color: #000;
        span {
            color: #000;
        }
    }
}
@media (max-width: 992px) {
    .asset-class {
        width: 100%;
    text-align: left;
    margin-bottom: 8px;
    margin-right: 0;
    margin-left: 0;
    }
}
</style>